import { USERS } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchGetUsers = async () => {
  const response = await ApiRequestInterceptor(USERS.getUsers, "GET", null);

  if (response.code === 200) {
    return response.data?.users || [];
  }

  const errorMessage = response?.data?.error || "Error al obtener usuarios";
  throw new Error(errorMessage);
};
